import type { SupabaseClient } from "@supabase/supabase-js";

import type { CyanOwnerDecisionRepository } from "./cyanOwnerDecisionRepository";

import { CyanOwnerAuthorityService } from "./cyanOwnerAuthorityService";

import { SupabaseCyanOwnerDecisionRepository } from "./supabaseCyanOwnerDecisionRepository";

export function createCyanOwnerDecisionRepository(
  database: SupabaseClient,
): CyanOwnerDecisionRepository {
  return new SupabaseCyanOwnerDecisionRepository(database);
}

export function createCyanOwnerAuthorityService(
  database: SupabaseClient,
): CyanOwnerAuthorityService {
  return new CyanOwnerAuthorityService(
    createCyanOwnerDecisionRepository(database),
  );
}
